import React, { useEffect, useState } from "react";
import LatestStories from "../components/LatestStories/LatestStories";
import { Link, useNavigate } from "react-router-dom";
import qs from "qs";
import axios from "axios";
import {
  FETCH_ALL_ARTICLES_FROM_STRAPI,
  FETCH_ALL_PUBLICATIONS_FROM_STRAPI,
} from "../api/constants";
import Pagination from "../components/Pagination/Pagination";

export default function OurPublications() {
  const [data, setData] = useState(null);
  const [latestStories, setLatestStories] = useState([]);

  const [page, setPage] = useState(1);

  const [pageCount, setPageCount] = useState(1);

  const navigate = useNavigate();
  const fetchData = async () => {
    const query = qs.stringify(
      {
        populate: {
          featured_publication: {
            populate: "cover",
          },
          our_picks: {
            populate: ["cover", "category"],
          },
        },
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    );
    try {
      const res = await axios.get(
        `${FETCH_ALL_PUBLICATIONS_FROM_STRAPI}?${query}`
      );
      setData(res?.data?.data);
      if (res?.data?.data?.featured_publication?.length === 0) {
        navigate("/");
      }
    } catch (err) {
      console.log("Error Fetching Data");
      navigate("/");
    }
  };

  const fetchLatestStories = async (page = 1) => {
    const query = qs.stringify(
      {
        filters: {
          category: {
            slug: "publications",
          },
        },
        sort: ["published_date:desc"],
        pagination: { page: page, pageSize: 25 },
        fields: ["published_date", "title", "slug", "description"],
        populate: ["cover", "author", "author.avatar"],
      },
      {
        encodeValuesOnly: true, // prettify URL
      }
    );
    try {
      const res = await axios.get(`${FETCH_ALL_ARTICLES_FROM_STRAPI}?${query}`);
      setPageCount(res?.data?.meta?.pagination?.pageCount);
      setLatestStories(res?.data?.data);

      if (res?.data?.data.length === 0) {
        navigate("/");
      }
    } catch (err) {
      console.log("Error Fetching Data");
      navigate("/");
    }
  };

  useEffect(() => {
    fetchData();
  }, [navigate]);

  useEffect(() => {
    fetchLatestStories(page);
  }, [page]);

  return (
    <>
      {data?.featured_publication?.length === 0 ? (
        <div className="flex items-center bg-white justify-center min-h-screen">
          <div className="w-12 h-12 border-4 border-black border-dashed rounded-full animate-spin"></div>
        </div>
      ) : (
        <div className="bg-white">
          {/* Hero  Section Start */}
          <div className="pt-4 sm:pt-6 md:pt-10 lg:pt-5 bg-[#f4f7f9] w-full xl:max-w-[1500px] xl:mx-auto ">
            <Link
              to={`/our-publications/${data?.featured_publication?.slug}/`}
              reloadDocument={true}
              className="sm:flex sm:flex-row md:flex md:flex-row lg:relative"
            >
              <img
                className="object-cover h-[270px] md:h-[350px] w-[100%] sm:w-[50%] md:w-[50%] lg:w-[60%] lg:h-[500px] xl:h-[600px] 2xl:h-[700px] sm:order-2"
                src={
                  data?.featured_publication?.cover?.formats?.large?.url ||
                  data?.featured_publication?.cover?.url
                }
                alt={data?.featured_publication?.cover?.alternativeText}
              />
              {/* text section */}
              <div className="px-2 pb-10 md:pb-0 md:px-6 w-[100%] sm:w-[50%] md:w-[50%]  sm:order-1 lg:hidden">
                <div className="flex flex-col gap-2">
                  <div className="flex flex-row justify-between  mt-3 font-[lato] text-xs md:text-sm ">
                    <span className="text-bhagwa font-[lato]">
                      {new Date(
                        data?.featured_publication?.published_date
                      ).toLocaleDateString()}
                    </span>
                  </div>
                  <h2 className="font-[optima-lt-pro] text-2xl sm:text-3xl sm:line-clamp-4 tracking-wide line-clamp-3 md:text-4xl md:leading-tight lg:leading-none md:line-clamp-4 ">
                    {data?.featured_publication?.title}
                  </h2>
                </div>
              </div>
              {/* text section end */}

              {/*  Grey box section start */}
              <div className="w-[40%] md:order-1 bg-gray-900 hidden lg:block">
                <div className=" w-full"></div>
              </div>
              {/*  Grey box section end */}

              {/* White box section start */}
              <div className="hidden lg:block absolute inset-0 ml-5 xl:ml-0 xl:left-40 pl-8 pt-8 2xl:px-12 2xl:pb-20 2xl:pt-16 bg-white w-[500px] h-[450px] xl:h-[500px] 2xl:w-[600px] 2xl:h-[600px] my-auto ">
                <div className="flex flex-col gap-4 w-[85%] 2xl:w-[100%]">
                  <span className="text-bhagwa font-[lato] text-sm xl:text-sm 2xl:text-base">
                    {new Date(
                      data?.featured_publication?.published_date
                    ).toLocaleDateString()}
                  </span>
                  <h2 className="font-[optima-lt-pro] text-4xl xl:text-4xl 2xl:leading-snug line-clamp-3">
                    {data?.featured_publication?.title}
                  </h2>
                  <p className="font-[lato] font-light text-lg xl:text-lg xl:leading-10 line-clamp-6 leading-8 2xl:leading-9">
                    {data?.featured_publication?.description}
                  </p>
                </div>
              </div>
              {/* White box section end */}
            </Link>
          </div>
          <div className="h-[40px] xs:h-[35px] w-full bg-gray-900 sm:hidden " />
          {/* Hero  Section End */}

          <div className="pt-12 xl:pt-24 lg:px-10  px-4 md:px-8 xl:px-16 md:mx-auto xl:max-w-7xl xl:mx-auto 2xl:px-0 ">
            <div className="flex flex-col gap-2 mb-4 2xl:gap-4 2xl:mb-8">
              {/* heading */}
              <span className="font-[lato] text-xs md:text-xs xl:text-sm text-bhagwa font-normal tracking-wide uppercase">
                Browse and read the latest stuff
              </span>

              <h2 className="font-[optima-lt-pro] text-3xl sm:text-3xl uppercase md:text-4xl 2xl:text-5xl text-black font-normal">
                Latest Stories
              </h2>
            </div>

            {/* Latest Stories */}
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-9">
              {latestStories?.map((item, index) => {
                return <LatestStories key={index} latestStoriesData={item} />;
              })}
            </div>

            {/* Pagination */}
            <div className="py-4">
              <Pagination
                page={page}
                pageCount={pageCount}
                onPageChange={(newPage) => {
                  setPage(newPage);
                }}
              />
            </div>

            {/* Staff Picks Start */}
            <div className="md:mt-16 lg:mt-24 xl:mt-24 mb-12">
              <div className="flex flex-col gap-2 mb-4 2xl:gap-4 2xl:mb-8">
                {/* heading */}
                <span className="font-[lato] text-xs md:text-xs xl:text-sm text-bhagwa font-normal tracking-wide uppercase">
                  You have to read this!
                </span>

                <h2 className="font-[optima-lt-pro] text-3xl sm:text-3xl uppercase md:text-4xl 2xl:text-5xl text-black font-normal">
                  XR's Picks
                </h2>
              </div>
              <div className="grid grid-cols-1 gap-8 md:grid md:grid-cols-1  lg:grid-cols-2 lg:h-[auto] xl:h-[900px] md:gap-8 lg:gap-16">
                <Link
                  to={`/${
                    data?.our_picks[0]?.category?.slug === "blog"
                      ? "blogs"
                      : data?.our_picks[0]?.category?.slug === "news"
                      ? "real-estate-news"
                      : "our-publications"
                  }/${data?.our_picks[0]?.slug}/`}
                  reloadDocument={true}
                  className="flex flex-col gap-8 md:gap-8 lg:gap-12 xl:gap-12"
                >
                  <div className="w-full h-[350px] md:h-[600px] lg:h-[60%] xl:h-[70%] ">
                    <img
                      className="w-full h-full object-cover"
                      src={
                        data?.our_picks[0]?.cover?.formats?.large?.url ||
                        data?.our_picks[0]?.cover?.url
                      }
                      alt={data?.our_picks[0]?.cover?.alternativeText}
                    />
                  </div>
                  <div className="flex flex-col h-[auto]  md:h-[20%] lg:h-[40%] xl:h-[30%] lg:gap-4 ">
                    <h2 className="text-2xl md:text-4xl xl:text-4xl font-normal font-[optima-lt-pro] line-clamp-2">
                      {data?.our_picks[0]?.title}
                    </h2>
                    <p className="mt-3 text-base xl:text-xl font-[lato] font-light">
                      {data?.our_picks[0]?.description}
                    </p>
                    <button className="flex flex-row items-center font-[lato] xl:text-base gap-1 mt-4 text-bhagwa text-xs uppercase group">
                      {"Read More"}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        stroke-width="1.5"
                        stroke="currentColor"
                        className="size-6 transition-all duration-300 group-hover:translate-x-1"
                      >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                        />
                      </svg>
                    </button>
                  </div>
                </Link>
                <div className="grid grid-cols-1 gap-6 md:grid md:grid-cols-2 md:gap-8  lg:flex lg:flex-col  lg:gap-10">
                  {data?.our_picks?.slice(1)?.map((item, index) => {
                    return (
                      <Link
                        to={`/${
                          item?.category?.slug === "blog"
                            ? "blogs"
                            : item?.category?.slug === "news"
                            ? "real-estate-news"
                            : "our-publications"
                        }/${item?.slug}/`}
                        reloadDocument={true}
                        key={index}
                        className="h-[auto] grid grid-cols-1 gap-2 md:h-auto md:grid md:grid-cols-1 md:gap-4 lg:grid-cols-2 "
                      >
                        <div className="md:w-full lg:w-[90%] h-[250px] md:h-[200px]">
                          <img
                            className="w-full h-full object-cover"
                            src={
                              item?.cover?.formats?.large?.url ||
                              item?.cover?.url
                            }
                            alt={item?.cover?.alternativeText}
                          />
                        </div>
                        <div className="flex flex-col ">
                          <h2 className="font-[optima-lt-pro] text-2xl md:text-3xl font-normal line-clamp-3">
                            {item?.title}
                          </h2>
                          <p className="mt-3 text-base md:text-base xl:text-xl font-[lato] font-light line-clamp-4">
                            {item?.description}
                          </p>
                          <button className="flex flex-row items-center font-[lato] xl:text-base gap-1 mt-4 text-bhagwa text-xs uppercase group ">
                            {"Read More"}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              stroke-width="1.5"
                              stroke="currentColor"
                              className="size-6 transition-all duration-300 group-hover:translate-x-1"
                            >
                              <path
                                stroke-linecap="round"
                                stroke-linejoin="round"
                                d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
                              />
                            </svg>
                          </button>
                        </div>
                      </Link>
                    );
                  })}
                </div>
              </div>
            </div>

            {/* Staff Picks End */}
          </div>
        </div>
      )}
    </>
  );
}
